import { render, staticRenderFns } from "./CampaignCard.vue?vue&type=template&id=bb3be6a2"
import script from "./CampaignCard.vue?vue&type=script&lang=js"
export * from "./CampaignCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignCard.vue?vue&type=style&index=0&id=bb3be6a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports